// Piezas pequeñas que repiten varias pantallas de la consola.
import { useState, type ReactNode } from 'react';
import { Badge, Button } from '@glubi/ds';
import { useSesion } from '../lib/sesion';

export function Copiable({ texto, etiqueta }: { texto: string; etiqueta?: string }) {
  const [copiado, setCopiado] = useState(false);
  return (
    <div className="stack" style={{ gap: 6 }}>
      {etiqueta && <span className="etiqueta">{etiqueta}</span>}
      <div style={{ position: 'relative' }}>
        <pre className="codigo" style={{ paddingRight: 84 }}>{texto}</pre>
        <div style={{ position: 'absolute', top: 4, right: 4 }}>
          <Button size="sm" variant="ghost" icon={copiado ? 'check' : 'copy'} onClick={() => {
            void navigator.clipboard?.writeText(texto).then(() => { setCopiado(true); setTimeout(() => setCopiado(false), 1600); });
          }}>{copiado ? 'Listo' : 'Copiar'}</Button>
        </div>
      </div>
    </div>
  );
}

export function Area({ label, value, onChange, filas = 4, placeholder, mono }: { label: string; value: string; onChange: (v: string) => void; filas?: number; placeholder?: string; mono?: boolean }) {
  return (
    <label className="stack" style={{ gap: 6 }}>
      <span className="etiqueta">{label}</span>
      <textarea className="field" rows={filas} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)}
        style={mono ? { fontFamily: 'ui-monospace,SFMono-Regular,Menlo,monospace', fontSize: 13, lineHeight: '19px' } : undefined} />
    </label>
  );
}

export function Casilla({ checked, onChange, children }: { checked: boolean; onChange: (v: boolean) => void; children: ReactNode }) {
  return <label className="check"><input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} /><span>{children}</span></label>;
}

export function Estado({ estado }: { estado: string }) {
  const m: Record<string, [ 'ok' | 'error' | 'pending' | 'neutral', string]> = {
    activo: ['ok', 'Activo'], pausado: ['pending', 'Pausado'], revocado: ['neutral', 'Revocado'],
    ok: ['ok', 'Bien'], error: ['error', 'Error'], rechazada: ['pending', 'Rechazada'],
    en_cola: ['neutral', 'En cola'], corriendo: ['pending', 'Trabajando'], esperando_aprobacion: ['pending', 'Necesita tu atención'],
    terminada: ['ok', 'Terminó'], fallida: ['error', 'Falló'], cancelada: ['neutral', 'Cancelada'],
    pendiente: ['pending', 'Pendiente'], aprobada: ['ok', 'Aprobada'], vencida: ['neutral', 'Vencida'],
  };
  const [s, t] = m[estado] ?? ['neutral', estado];
  return <Badge state={s}>{t}</Badge>;
}

// Quien solo puede ver no encuentra botones que lo van a rechazar.
export function SoloSiAdministra({ children }: { children: ReactNode }) {
  const { cuenta } = useSesion();
  return cuenta?.puedeAdministrar ? <>{children}</> : null;
}

export function AvisoSoloVer() {
  const { cuenta } = useSesion();
  if (cuenta?.puedeAdministrar) return null;
  return <div className="aviso-caja" style={{ marginBottom: 16 }}>Puedes ver el gateway de {cuenta?.cuenta}, pero cambiarlo es del administrador o de un implementador con su permiso de tokens.</div>;
}
